import { Message } from '@/modules/message/service/message-service.tsx'

export function areMessagesDifferent(
  initial: Message[],
  updated: Message[],
): boolean {
  if (initial.length !== updated.length) {
    return true
  }

  return initial.some((initialMessage, messageIndex) => {
    const updatedMessage = updated[messageIndex]

    if (!updatedMessage) {
      return true
    }

    if (initialMessage.text !== updatedMessage.text) {
      return true
    }

    if (initialMessage.fallbackVariable !== updatedMessage.fallbackVariable) {
      return true
    }

    if (initialMessage.fallback !== updatedMessage.fallback) {
      return true
    }

    if (initialMessage.price !== updatedMessage.price) {
      return true
    }

    const initialMedias = initialMessage.medias ?? []
    const updatedMedias = updatedMessage.medias ?? []

    if (initialMedias.length !== updatedMedias.length) {
      return true
    }

    return initialMedias.some(
      (media, mediaIndex) =>
        media.mediaId !== updatedMedias[mediaIndex]?.mediaId,
    )
  })
}
